/** Small formatting helpers shared by the billing screens. */

export const day = (iso: string | null | undefined): string =>
  iso
    ? new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';

export const dayTime = (iso: string | null | undefined): string =>
  iso
    ? new Date(iso).toLocaleString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '';

/** Cents as money in the currency ("€5.99" style, whatever the browser's English uses). */
export function formatMoney(cents: number, currency: string): string {
  try {
    return new Intl.NumberFormat('en', { style: 'currency', currency }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

/** Whole days from now to `iso` (negative once passed); null when there is no date. */
export function daysFromNow(iso: string | null | undefined, now = Date.now()): number | null {
  return iso ? Math.ceil((Date.parse(iso) - now) / 86400000) : null;
}

/** Today as 'YYYY-MM-DD' (UTC, which is how the server counts days). */
export const today = (): string => new Date().toISOString().slice(0, 10);

/** The first day of this month / this year / of the month a year ago, as 'YYYY-MM-DD' (UTC). */
export function startOf(unit: 'month' | 'year' | 'yearAgo', now = new Date()): string {
  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const d =
    unit === 'month'
      ? Date.UTC(y, m, 1)
      : unit === 'year'
        ? Date.UTC(y, 0, 1)
        : Date.UTC(y - 1, m + 1, 1);
  return new Date(d).toISOString().slice(0, 10);
}
